/**
 * This agent's custom surface components — the client half of the agent's
 * catalog (server half: `agent-dev-server/src/surfaces/`). Each entry maps a
 * `ComponentContract.component` name to its React realization; add one line
 * per screen the builder authors. `SurfaceRenderer` consults this before the
 * platform builtin catalog and the v1 primitives.
 */
import type { FC } from 'react';
import type { A2uiNodeViewProps } from '@/app/lib/a2ui/catalog.tsx';
import { Contact } from './Contact.tsx';
import { GameForFun } from './GameForFun.tsx';
import { DestinationShortlist } from './DestinationShortlist.tsx';
import { SurpriseTravellerPopup } from './SurpriseTravellerPopup.tsx';
import { TripBooking } from './TripBooking.tsx';
import { TravelPassport } from './TravelPassport.tsx';
import { TripKickoff } from './TripKickoff.tsx';
import { TripPlanComparison } from './TripPlanComparison.tsx';

export const AGENT_SURFACE_COMPONENTS: Record<string, FC<A2uiNodeViewProps>> = {
  Contact,
  GameForFun,
  TripKickoff,
  TravelPassport,
  DestinationShortlist,
  TripPlanComparison,
  TripBooking,
  SurpriseTravellerPopup,
};
